import React, { Component } from 'react'
import parse from 'html-react-parser'
import { apiConstants } from '../constants/apiConstants'
import { Message } from '@paypalcorp/worldready-react'

class Pagination extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      upperPageBound: 5,
      lowerPageBound: 0,
      pageNo: this.props.pageNo,
      pageBound: 5,
    }
  }

  btnIncrementClick = () => {
    const { upperPageBound, lowerPageBound, pageBound } = this.state
    this.setUpperBoundLowerBoundPageNo(
      upperPageBound + pageBound,
      lowerPageBound + pageBound,
      upperPageBound + 1,
    )
    this.setPageNo(upperPageBound + 1)
  }

  btnDecrementClick = () => {
    const { upperPageBound, lowerPageBound, pageBound } = this.state
    this.setUpperBoundLowerBoundPageNo(
      upperPageBound - pageBound,
      lowerPageBound - pageBound,
      upperPageBound - pageBound,
    )
    this.setPageNo(upperPageBound - pageBound)
  }

  setUpperBoundLowerBoundPageNo = (upperPageBound, lowerPageBound, pageNo) => {
    this.setState({ upperPageBound, lowerPageBound, pageNo })
  }

  onPageNoClick = (pageNo, type, totalPages, showButton) => {
    if (showButton) {
      switch (type) {
        case '':
          break
        case 'previous':
          pageNo = Math.max(pageNo - 1, 1)
          break
        case 'next':
          pageNo = Math.min(pageNo + 1, totalPages)
          break
        case 'first':
          pageNo = 1
          break
        case 'last':
          pageNo = totalPages
          break
        default:
          break
      }
      this.calculateUpperBoundLowerBound(pageNo, totalPages, type)
      this.setPageNo(pageNo)
    }
    return
  }

  calculateUpperBoundLowerBound = (pageNo, totalPages, type) => {
    let upperBound = 0,
      lowerBound = 0
    const { pageBound, upperPageBound, lowerPageBound } = this.state
    if ((type === '' || type === 'next') && pageNo > upperPageBound) {
      upperBound = upperPageBound + pageBound
      lowerBound = lowerPageBound + pageBound
    } else if (type === 'previous' && pageNo % pageBound === 0) {
      upperBound = upperPageBound - pageBound
      lowerBound = lowerPageBound - pageBound
    } else if (type === 'last') {
      upperBound = totalPages
      lowerBound = totalPages - (totalPages % pageBound)
    } else if (type === 'first') {
      upperBound = 5
    } else {
      upperBound = upperPageBound
      lowerBound = lowerPageBound
    }
    this.setState({
      pageNo,
      upperPageBound: upperBound,
      lowerPageBound: lowerBound,
    })
  }

  setPageNo = (pageNo) => {
    this.props.onPaginationClick(pageNo)
  }

  renderPageButton = (totalPages, pageNo, showButton, label, type) => {
    return (
      <li key={`${label}-arrow`}>
        <a
          className={`ppvx_pagination_page-arrow ppvx_pagination_arrow ppvx_pagination_arrow-${label} pagination__button-enable ${
            showButton ? '' : 'pagination__button-disable'
          }`}
          onClick={() =>
            this.onPageNoClick(pageNo, type, totalPages, showButton)
          }
          aria-label={`${parse(label)}`}
        />
      </li>
    )
  }

  renderEllipseForExtraPage = (callback) => {
    return (
      <li onClick={() => callback()}>
        <a className="ppvx_pagination_page-number">&hellip;</a>
      </li>
    )
  }

  renderElementsInPage = (startIndex, endIndex, pageNo, totalPages) => {
    const { totalElements } = this.props
    let elements = ''
    if (pageNo === totalPages && pageNo !== 1) {
      elements = (
        <Message
          id="labels.pagination.showing.total"
          start={startIndex}
          total={totalElements}
        />
      )
    } else if (pageNo !== 1) {
      elements = (
        <Message
          id="labels.pagination.showing.end"
          start={startIndex}
          total={totalElements}
          end={endIndex}
        />
      )
    } else {
      elements = (
        <Message
          id="labels.pagination.showing.basic"
          total={totalElements}
          end={endIndex}
        />
      )
    }
    return <div className="pagination__count">{elements}</div>
  }

  renderPagination = (totalPages, pageNo) => {
    const { upperPageBound, lowerPageBound } = this.state
    const { pageLimit } = this.props

    const showPrevious = pageNo !== 1,
      showNext = pageNo !== totalPages
    const pageNumber = []
    const pageNumbers = []
    for (let index = 1; index <= totalPages; index++) {
      pageNumbers.push(index)
    }
    for (let index = 1; index <= totalPages; index++) {
      if (
        (index === 1 && pageNo === 1) ||
        (index < upperPageBound + 1 && index > lowerPageBound)
      ) {
        pageNumber.push(
          <li
            key={index}
            onClick={() => this.onPageNoClick(index, '', totalPages, true)}
          >
            <a
              className={`ppvx_pagination_page-number ${
                index === pageNo ? 'ppvx_pagination_current-page' : ''
              }`}
            >
              {index}
            </a>
          </li>,
        )
      }
    }

    let startIndex = (pageNo - 1) * pageLimit + 1
    let endIndex = startIndex + pageLimit - 1

    let pageIncrementBtn = null
    if (pageNumbers.length > upperPageBound) {
      pageIncrementBtn = this.renderEllipseForExtraPage(this.btnIncrementClick)
    }

    let pageDecrementBtn = null
    if (lowerPageBound >= 1) {
      pageDecrementBtn = this.renderEllipseForExtraPage(this.btnDecrementClick)
    }

    return (
      <div className="pagination__holder">
        <div className="pagination__container">
          <div className="pagination__count-container">
            {this.renderElementsInPage(
              startIndex,
              endIndex,
              pageNo,
              totalPages,
            )}
          </div>
          <ul className="pagination__button-holder ppvx_text--md">
            {apiConstants.PaginationLabel.map((item) => {
              return item.key === 'first' ||
                item.key === 'previous' ||
                item.key === 'next' ||
                item.key === 'last' ? (
                this.renderPageButton(
                  totalPages,
                  pageNo,
                  item.key === 'previous' || item.key === 'first'
                    ? showPrevious
                    : showNext,
                  item.label,
                  item.key,
                )
              ) : (
                <React.Fragment key="pagination__button-labels">
                  {' '}
                  {pageDecrementBtn}
                  {pageNumber}
                  {pageIncrementBtn}
                </React.Fragment>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }

  render() {
    const { totalPages } = this.props
    const { pageNo } = this.state
    return this.renderPagination(totalPages, pageNo)
  }
}

export default Pagination
